// extracted by css-extract-rspack-plugin
export default {"containerWrapper":"_a9ba0f9d","wrapper":"_68c9019a","relatedDesignItemWrapper":"_7e4dca72"};